<ds-text-field
  [name]="name"
  [label]="label"
  [placeholder]="placeholder"
  [helpertext]="invalid ? invalidtext : helpertext"
  [type]="type"
  [value]="value"
  [required]="required"
  [disabled]="disabled || dsDisabled"
  [invalid]="invalid"
  (dsChange)="onDsChange($event)"
></ds-text-field>
